import {fetchUserLocationAndSetDefault} from "../index";
import {setState} from "../../index";

/* Initializes the tax country selector functionality */
export function initTaxCountrySelector(){
  const allCountries = cartState.all_countries ? cartState.all_countries : [];
  const gatewayTaxSummary = document.querySelector('.tax-summary');
  const taxSelected = document.querySelector('.tax-selected');
  const optionsContainer = document.querySelector('.options-container');
  const taxSelectbox = document.querySelector('.tax-selectbox');
  const countrySearch = document.querySelector('#country-search');
  const selectedCountryHiddenField = document.querySelector("input[data-recurly='country']");
  let optionToSelect = document.querySelector('.country-option.option-selected .radio');

  if (gatewayTaxSummary) {
    // Fetch user location and set the default country on page load
    fetchUserLocationAndSetDefault(allCountries, gatewayTaxSummary);

    taxSelected.addEventListener('click', e => {
      e.stopPropagation();
      taxSelectbox.classList.toggle('active');
      countrySearch.focus();
    });

    document.addEventListener('click', e => {
      if (e.target !== countrySearch) {
        taxSelectbox.classList.remove('active');
      }
    });

    optionsContainer.addEventListener('click', function (e) {
      let optionElement = e.target;
      if (!optionElement.classList.contains('country-option')) {
        optionElement = optionElement.closest('.country-option');
      }

      if (optionElement) {
        const previous = document.querySelector('.option-selected');
        previous && previous.classList.contains('option-selected') && previous.classList.remove('option-selected');
        optionToSelect = optionElement.querySelector('.radio');
        let selectedCountryCode = optionElement.querySelector('.radio').value;
        taxSelected.innerHTML = optionElement.querySelector('label').innerHTML;
        optionElement.className += ' option-selected';
        setState({user_country: selectedCountryCode});
        if (selectedCountryHiddenField) selectedCountryHiddenField.value = selectedCountryCode;
        taxSelectbox.classList.remove('active');
      }
    });

    countrySearch.addEventListener('keyup', function (e) {
      let res = '';

      allCountries.map(val => {
        if (val.country_name.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1) {
          res += `<div class="country-option ${optionToSelect?.value == val.iso2 ? 'option-selected' : ''}">
                      <input type="radio" class="radio" id="vat-${val.iso2}" name="Country" value="${val.iso2}">
                      <img loading="lazy" src="https://images.purevpn-tools.com/public/images/tickmark-dropdown.png" alt="" class="img-responsive img-selected">
                      <label for="${val.iso2}">${val.country_name}</label>
                  </div>`;
        }
      });

      optionsContainer.innerHTML = res;
    });
  }
}
